import React from "react";
import { Spinner } from "reactstrap";

export const CenteredSpinner = () => (<div className="d-flex justify-content-center">
  <Spinner animation="border" variant="primary" aria-busy="true" />
</div>);